export const FileSizes = {
  MaxUniversalFormFileSize: 3 * 1024 ** 2, // 3mb
};
